import React, {useEffect, useState} from "react";
import {TbLoader} from "react-icons/tb";
import {BiCategory, BiDollarCircle, BiPulse, BiSpreadsheet,} from "react-icons/bi";
import {NumericFormat} from 'react-number-format';
import DatePicker from "react-datepicker";

//CUSTOM COMPONENTS
import {getDashboard} from "../../../helpers/Api";
import MainLayout from "../../../components/MainLayout";
import TabAdminAaaver from "../ListadoAgentes/TabAdminAaaver";

import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip
} from "chart.js";

import {Bar} from 'react-chartjs-2';
import { ASOCIACION_USER } from "../../../constants";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend 
)

const Dashboard = () => {
  //Credencials
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  //States
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [chartData, setCharData] = useState([]);


  //variables to go back on month
  const startingDateDefault = new Date();
  const endDateDefault = new Date(startingDateDefault); 
  endDateDefault.setMonth(startingDateDefault.getMonth() - 1);

  const [startingDate, setStartingDate] = useState(startingDateDefault);
  const [endDate, setEndDate] = useState(endDateDefault);
  const [query, setQuery] = useState(0);


  useEffect(() => {
    startingDate && getAllDashboardInfo();
  }, [endDate]);


  //Function to parse information from react Data picker data to the endpoint formatt. 
  const formatDate = (date) => {
    if (!date) return '';
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
  };

  //Handler from Reac DataPicker
  const handlerDate = (dates) => {
    const [fechaInicio, fechaFinal] = dates;
    setStartingDate(fechaInicio);
    setEndDate(fechaFinal);
    setQuery(query + 1)
  };
  

  const getAllDashboardInfo = async () => {
    try {
      const response = await getDashboard( formatDate(startingDate), formatDate(endDate), token);
      if (response) {
        setData(response);
        setCharData(response.deuda_historial)
        
      }
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const transformDataDeuda = (dataProcess) => {
    const labels = [];
    const deudaTotalData = [];
    dataProcess.forEach((dayData) => {
      dayData.forEach((entry) => {
        labels.push(entry?.fecha.slice(0, 10));
        deudaTotalData.push(entry?.deuda_total);
      }
      );
    });
    return {
      labels,
      datasets: [
        {
          label: 'Deuda Total',
          data: deudaTotalData,
          backgroundColor: '#2C74FE',
          borderWidth: 0,
        },
      ],
    };
  };


  const transformDataContenedorDeuda = (dataProcess) => {
    const labels = [];
    const contenedoresDeudaData = [];
    dataProcess.forEach((dayData) => {
      dayData.forEach((entry) => {
        labels.push(entry?.fecha.slice(0, 10));
        contenedoresDeudaData.push(entry?.contenedores_deuda);
      }
      );
    });
    return {
      labels,
      datasets: [
        {
          label: 'Deuda Contenedores',
          data: contenedoresDeudaData,
          backgroundColor: '#FF8888',
          borderWidth: 0,
        },
      ],
    };
  };

  const transformedDataDeuda = transformDataDeuda(chartData);
  const transformedDataContainer = transformDataContenedorDeuda(chartData);

  return (
    <MainLayout>
      <div className="row title_layout">
        <div className="col-6">
          <h5>DASHBOARD</h5>
        </div>
        <div className="col-6 d-flex flex-row-reverse">
          <TabAdminAaaver />
        </div>
      </div>
      {loading ? (
        <div className="row">
          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "4rem" }}
          >
            <TbLoader
              color={"rgb(10, 132, 254)"}
              className="loader"
              size={"3rem"}
            />
          </div>
        </div>
      ) : (
        <>
          <div className="row d-flex justify-content-center">
          <div className="col-md-4 col-sm-12">
            <div className="table_dashboard d-flex flex-column">
              <p className="table_dashboard_title d-flex align-items-center">
                <BiSpreadsheet
                  size={"38px"}
                  color="#ABEBFF"
                  style={{
                    backgroundColor: "#2C74FE",
                    borderRadius: "50%",
                    padding: "4px",
                    marginRight: "8px",
                  }}
                />{" "}
                Operaciones
              </p>
              <p style={{paddingLeft: '10px'}}><b>Pendientes:</b> {data.operaciones?.pendientes}</p>
              <p><span className="table_dashboard_badge">
              Total:
              <NumericFormat 
                prefix={" "} suffix={""}
                decimalSeparator={"."}
                thousandSeparator={true}
                decimalScale={0}
                fixedDecimalScale={true}
                displayType="text" 
                value={data.operaciones?.total} 
                />  
            </span></p>
            </div>
            </div>
            
            <div className="col-md-4 col-sm-12">
            <div className="table_dashboard d-flex flex-column">
              <p className="table_dashboard_title">
                <BiCategory
                  size={"38px"}
                  color="#FFF8B8"
                  style={{
                    backgroundColor: "#FFC962",
                    borderRadius: "50%",
                    padding: "4px",
                    marginRight: "8px",
                  }}
                />
                Contenedores
              </p>
              <p style={{paddingLeft: '10px'}}><b>Pendientes:</b> {data.contenedores?.pendientes}</p>
              <p>
              <span className="table_dashboard_badge">
              Total: 
              <NumericFormat 
                prefix={" "} suffix={""}
                decimalSeparator={"."}
                thousandSeparator={true}
                decimalScale={0}
                fixedDecimalScale={true}
                displayType="text" 
                value={data.contenedores?.total} 
                />
               </span>
              </p>
            </div>  
          </div>
            <div className="col-md-4 col-sm-12">
            <div className="table_dashboard d-flex flex-column">
              <p className="table_dashboard_title">
                <BiDollarCircle
                  size={"38px"}
                  color="#ACFFB5"
                  style={{
                    backgroundColor: "#5CDC80",
                    borderRadius: "50%",
                    padding: "4px",
                    marginRight: "8px",
                  }}
                />
                Deuda
              </p>
              <br/>
              <p></p>
              <p>
              <span className="table_dashboard_badge">
              Total: 
              <NumericFormat 
                prefix={" $"} suffix={" USD"}
                decimalSeparator={"."}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                displayType="text" 
                value={data?.deuda_total} 
                />
            </span>
              </p>
            </div>
            </div>
          </div>

          <div className="row d-flex justify-content-center">
          <div className="col-md-4 col-sm-12">
            <div className="table_dashboard_tops">
              <p className="table_dashboard_title mt-3">Top 10 patentes</p>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">No.</th>
                      <th scope="col">Patente</th>
                      <th scope="col">Monto</th>
                    </tr>
                  </thead>
                  {data.top_patentes?.map((value, index) => (
                    <tbody key={index}>
                      <tr>
                        <td style={{ paddingTop: "3.1rem" }}>{index + 1}</td>
                        <td style={{ paddingTop: "3.1rem" }}>
                          {value.patente}
                        </td>
                        <td style={{ paddingTop: "3.1rem" }}>
                        <NumericFormat 
                        prefix={"$"} suffix={" USD"}  
                        decimalSeparator={"."}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text" 
                        value={value?.monto} 
                      />
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
            </div>
            <div className="col-md-4 col-sm-12">
            <div className="table_dashboard_tops">
              <p className="table_dashboard_title mt-3">Top 10 clientes</p>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">No.</th>
                      <th scope="col">Cliente</th>
                      <th scope="col">Monto</th>
                    </tr>
                  </thead>
                  {data.top_clientes?.map((value, index) => (
                    <tbody key={index}>
                      <tr>
                        <td style={{ paddingTop: "3.1rem" }}>{index + 1}</td>
                        <td style={{ paddingTop: "3.1rem" }}>
                          {value.cliente}
                        </td>
                        <td style={{ paddingTop: "3.1rem" }}>
                        <NumericFormat 
                        prefix={"$"} suffix={" USD"}  
                        decimalSeparator={"."}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text" 
                        value={value?.monto} 
                      />
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
            </div>

            {role === ASOCIACION_USER &&
            <div className="col-md-4 col-sm-12">
            <div className="table_dashboard_tops">
              <p className="table_dashboard_title mt-3">Top 5 navieras</p>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">No.</th>
                      <th scope="col">Patente</th>
                      <th scope="col">Monto</th>
                    </tr>
                  </thead>
                  {data.top_navieras?.map((value, index) => (
                    <tbody key={index}>
                      <tr>
                        <td style={{ paddingTop: "3.1rem" }}>{index + 1}</td>
                        <td style={{ paddingTop: "3.1rem" }}>
                          {value.naviera}
                        </td>
                        <td style={{ paddingTop: "3.1rem" }}>
                        <NumericFormat 
                        prefix={"$"} suffix={" USD"}
                        decimalSeparator={"."}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text" 
                        value={value?.monto} 
                      />
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
            </div>
            }

            {role === ASOCIACION_USER &&
            <div className="col-12">
            <div className="table_dashboard">
            <div className="row d-flex justify-content-end">
              <div className="col-12">
                <p className="table_dashboard_title">
                <BiPulse
                  size={"38px"}
                  color="#FFBAF4"
                  style={{
                    backgroundColor: "#E91AA2",
                    borderRadius: "50%",
                    padding: "4px",
                    marginRight: "8px",
                  }}
                />
                Historial de deuda
              </p>
              </div>
              <div className="col-md-4 col-sm-12" style={{fontSize: '14px', backgroundColor: '#F1F1F1', padding: '4px', borderRadius: '10px'}}>
              {query !== 0 ? <p>Personalizado</p> : <p>Los últimos 28 días hasta hoy</p>}
                <DatePicker
                  className="form-control"
                  onChange={handlerDate}
                  startDate={startingDate}
                  endDate={endDate}
                  selectsRange
                  dateFormat='dd/MM/yyyy'
                  isClearable={true}
                  placeholderText="Buscar por fecha"
                />
              </div>
              <hr style={{ borderTop: "dotted 1px", marginTop: "1rem" }} />
               <Bar  
               style={{padding: '4rem'}}
               data={transformedDataDeuda}
              //  options={options}
               />
                 <Bar  
               style={{padding: '4rem'}}
               data={transformedDataContainer}
              //  options={options}
               />
              </div>
            </div>
          </div>}
          </div>
        </>
      )}
    </MainLayout>
  );
};

export default Dashboard;
